import styled from "styled-components";
import {ACTION_CONTROL_HEIGHT_PX, fontFamilies, motion, radii, zIndex} from "theme/tokens";

/**
 * The owner's mockup B (kitecorp/transferify-ui#4043): an arrow and the words, in a pill, in the corner opposite the
 * cookie settings button. It takes that button's choices (`consent/CookieSettingsLauncher.styles`) and its bottom inset,
 * so the two sit level, and for the same reasons: `zIndex.nav` puts every dialog over it with no hiding logic to keep in
 * step, and only the inset tightens on a phone, never the 44px touch target.
 *
 * No safe-area inset, because the launcher has none: the viewport declares no `viewport-fit=cover`, so a browser
 * keeps the page, and this corner with it, inside the safe area.
 */
export const Pill = styled.button`
	position: fixed;
	right: 16px;
	bottom: 16px;
	z-index: ${zIndex.nav};

	display: flex;
	align-items: center;
	gap: 6px;
	height: ${ACTION_CONTROL_HEIGHT_PX}px;
	padding: 0 16px;
	border: 1px solid ${({theme}) => theme.tokens.cardBorder};
	border-radius: ${radii.pill};
	background: ${({theme}) => theme.tokens.card};
	color: ${({theme}) => theme.tokens.ink};
	font-family: ${fontFamilies.sans};
	font-size: 15px;
	font-weight: 600;
	line-height: 1;
	white-space: nowrap;
	cursor: pointer;
	box-shadow: ${({theme}) => theme.tokens.shadowCard};
	transition: border-color ${motion.hover} ${motion.easeOut};

	&:hover {
		border-color: ${({theme}) => theme.tokens.ink2};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.ring};
		outline-offset: 2px;
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	@media (max-width: 480px) {
		right: 12px;
		bottom: 12px;
	}

	@media print {
		display: none;
	}
`;
